<div class="filters-container">
  <form [formGroup]="questionsFilterFrom" class="filters-flex-wrapper">
    <!-- Main Filter Group (Dropdowns + Apply) -->
    <div class="filter-main-group">
      <!-- Topics / Languages Multi-select -->
      <div class="filter-box multi-select-box" [class.is-expanded]="isTopicExpanded">
        <div class="filter-icon">
          <mat-icon>{{ activeTabIndex !== 2 ? 'topic' : 'language' }}</mat-icon>
        </div>
        <div class="filter-content">
          <ng-multiselect-dropdown *ngIf="activeTabIndex !== 2; else codingLanguagesTpl" [placeholder]="'Select Topics'"
            [settings]="topicsSettings" [data]="topics" formControlName="topics" (onDropDownOpen)="onMultiSelectOpen()"
            (onDropDownClose)="onMultiSelectClose()">
          </ng-multiselect-dropdown>
          <ng-template #codingLanguagesTpl>
            <ng-multiselect-dropdown [placeholder]="'Select Languages'" [settings]="languagesSettings"
              [data]="languages" formControlName="languages" (onDropDownOpen)="onMultiSelectOpen()"
              (onDropDownClose)="onMultiSelectClose()">
            </ng-multiselect-dropdown>
          </ng-template>
        </div>
      </div>

      <!-- Difficulty level Dropdown -->
      <div class="filter-box menu-select-box">
        <div class="filter-icon">
          <mat-icon>signal_cellular_alt</mat-icon>
        </div>
        <div class="filter-content">
          <mat-form-field appearance="fill" class="minimal-select">
            <mat-select formControlName="difficultyLevel" multiple placeholder="Difficulty">
              <mat-option [value]="level" *ngFor="let level of difficultyLevels">{{level |
                difficultyLevel}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="filter-actions">
        <button mat-flat-button color="primary" class="apply-btn-premium" (click)="onApply()">
          <mat-icon>filter_list</mat-icon>
          <span>Apply</span>
        </button>
        <button mat-button class="clear-btn-premium" *ngIf="showClearButton" (click)="onClear()">
          <span>Clear</span>
        </button>
      </div>
    </div>

    <!-- Spacer -->
    <div class="flex-spacer"></div>

    <!-- Search Bar Section -->
    <div class="search-section-premium">
      <div class="search-input-wrapper">
        <mat-icon class="search-side-icon">search</mat-icon>
        <input placeholder="Search questions..." class="premium-search-input" formControlName="searchTerm"
          (keyup.enter)="onSearch()" />
        <button mat-icon-button class="search-clear-btn" *ngIf="questionsFilterFrom.get('searchTerm')?.value"
          (click)="onClearSearch()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </form>
</div>